<app-container-header>
  <!-- Content Main -->
  <div contentMain class="company-list">
    <app-progress-spinner
      *ngIf="
        companyService.loadingCompanies || selectingCompany;
        else showPicker
      "
      [diameter]="40"
    ></app-progress-spinner>

    <div>
      <ng-template #showPicker>
        <ng-container *ngIf="companies$ | async as companies">
          <app-companies-list
            [companies]="companies"
            (chooseCompany)="chooseCompany($event)"
          ></app-companies-list>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <!-- Content Main -->
</app-container-header>
